import React, { useMemo } from "react";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { transferRequestForm } from "../../../shared/formObjects/application/transferRequestForm";
import { useApiClient } from "../../../shared/customHooks";

export default function TransferRequestComponent({ disabled, data, showBack = false }: any) {
  const {
    application: { nextApplicationId, hasTransfer },
    applicationBase,
    id,
  } = useApplicationContext();

  const context = useMemo(() => {
    return {
      nextApplicationId,
      hasTransfer,
      discriminator: applicationBase.discriminator,
    };
  }, []);

  return (
    <>
      {applicationBase.assignStatus?.statusComputed == "Finalised - Transfer Received" && (
        <BaseApplicationComponent
          formBody={transferRequestForm}
          headerLabel="Child Transfer"
          editPath="transferRequest"
          apiClient={useApiClient("TransferRequestCurrent")}
          disabled={disabled || hasTransfer}
          showInternalNotes={false}
          formContext={context}
          data={data}
          showBack={showBack}
          showEdit={!hasTransfer}
          id={id}
        />
      )}
    </>
  );
}
